import React, { useEffect, useState, useMemo } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import { TextField, Popover, FormControl, makeStyles, Backdrop, Button } from '@material-ui/core';
import moment from "moment";
import { globalStyles } from "../utils/globalStyles";

const dateFormat = 'DD MMMM Y';

const useStyles = makeStyles((theme) => ({
    flexDirection: {
        flexDirection: 'row',
    },
    paddRight: {
        paddingRight: theme.spacing(3)
    },
    backdrop: {
        zIndex: theme.zIndex.modal,
        backgroundColor: 'rgba(255, 255, 255, .75)',
    },
    popover: {
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        borderRadius: 0,
    },
    submitBtn: {
        alignSelf: 'center',
    }
}));

export default ({state, setState, constants, formEl}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = useMemo(() => Boolean(anchorEl), [anchorEl]);
    const id = open ? 'simple-popover' : undefined;

    const [dateRange, setDateRange] = useState([]);

    const [inputValue, setInputValue] = useState({
        start: '',
        end: ''
    });

    useEffect(() => {
        setInputValue({
            start: state.startDate.format(dateFormat),
            end: state.endDate.format(dateFormat)
        });

        setDateRange([
            {
                startDate: new Date(state.startDate),
                endDate: new Date(state.endDate),
                key: 'selection'
            }
        ]);
    }, [open, state]);

    const handleDateChange = item => setDateRange([item.selection]);

    const handleSubmit = () => {
        setState({...state, pageIndex: 0, startDate: moment(dateRange[0].startDate), endDate: moment(dateRange[0].endDate)});
        setAnchorEl(null);
    };

    const handleClick = event => setAnchorEl(event.currentTarget);

    return (
        <>
            <Backdrop className={classes.backdrop} open={open} />
            <FormControl fullWidth className={classes.flexDirection} aria-describedby={id} onClick={handleClick}>
                <TextField className={classes.paddRight} fullWidth value={inputValue.start}  id="input-start-date" label="Start Date" />
                <TextField className={classes.paddRight} fullWidth value={inputValue.end}  id="input-end-date" label="End Date" />
            </FormControl>
            <Popover
                id={id}
                open={open}
                anchorEl={formEl.current}
                onClose={handleSubmit}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                classes={{paper: classes.popover}}
            >
                <DateRange
                    onChange={item => handleDateChange(item)}
                    months={2}
                    ranges={dateRange}
                    direction="horizontal"
                    editableDateInputs={true}
                    moveRangeOnFirstSelection={false}
                    dateDisplayFormat={'d MMMM yyyy'}
                    minDate={new Date(constants.initialStartDate.format())}
                    maxDate={new Date(constants.initialEndDate.format())}
                    rangeColors={[globalStyles.palette.secondaryColor.main]}
                />
                <Button className={classes.submitBtn} onClick={handleSubmit} variant="contained">Update</Button>
            </Popover>
        </>
    );
}
